import SwiperCentered from '../../components/swiper/centered';

const carouselReview = document.querySelectorAll('.carousel-review');

carouselReview.forEach((carousel) => {
  const swiperEl = carousel.querySelector('.swiper');

  // eslint-disable-next-line no-new
  if (swiperEl) new SwiperCentered(swiperEl);
});
